__webpack_require__.p = "https://kiosk.exhalemv.com/_next/";